import { RO_ITEM } from "MODULES/Orders/shared/constants";

export function isModTo(receivingRecord) {
  return (
    receivingRecord &&
    receivingRecord.type === RO_ITEM &&
    receivingRecord.mod_to_id
  );
}



// WEBPACK FOOTER //
// ./app/modules/Receiving/helpers.js